export const createQueryParameterString = (data: {[key: string]: any}): string => {
	let result = "?";
	Object.keys(data).forEach((key: string) => {
		result += `${key}=${data[key]}&`;
	});
	
	return result;
};

export const getQueryParameter = (key: string): string | null => {
	const queryParams = new URLSearchParams(window.location.search);
	return queryParams.get(key);
};
